import { ReactElement } from "react";
import { GroupedTableCellProps } from "./GroupedTableCell.types";
import { SmallBody } from "src/components/Text";

/**
 * GroupedTableCell component
 *
 * @param {GroupedTableCellProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function GroupedTableCell<TRow>({
    column,
    row,
}: GroupedTableCellProps<TRow>): ReactElement | null {
    if (!row) {
        return null;
    }

    return (
        <div className="GroupedTableCell">
            <SmallBody color="contentDark">
                {column.cell(row)}
            </SmallBody>
        </div>
    );
}

export default GroupedTableCell;

